module.exports = __webpack_public_path__ + "img/no-data.6bea9156.png";